import { useEffect, useState } from 'react';
import { EditNotesIcon, VoiceIcon } from 'src/icons';
import { NameIcon } from 'src/icons/Name.icon';
import { Input } from 'antd';
import { Button, Header, Text } from '../baseComponents';
import { useDispatch, useSelector } from 'react-redux';
import { editCarePlan } from 'src/store/actions/carePlan.action';
import { DownArrowIcon } from 'src/icons/Downarrow.icon';
const { TextArea } = Input;

const CarePlanPage = () => {
  const { getCarePlanvalue } = useSelector((state) => state?.carePlanState);
  const [textAreaValue, setTextAreaValue] = useState('');
  const [showChatHeader, setShowChatHeader] = useState(false);
  const { getUuid } = useSelector((state) => state?.appointmentState);
  const dispatch = useDispatch();

  useEffect(() => {
    const textAreaValue = getCarePlanvalue ? getCarePlanvalue : 'Loading...';
    // const textAreaValue = getUuid?.appointment_details?.supervised_careplan_summary ?
    //     getUuid?.appointment_details?.supervised_careplan_summary : getCarePlanvalue ?
    //     getCarePlanvalue : "Loading..."
    setTextAreaValue(textAreaValue);
  }, [getCarePlanvalue, getUuid]);

  const updateCareConnet = {
    appointment_id: getUuid?.appointment_details?.appointment_id,
    supervised_care_plan_summary: textAreaValue,
  };

  return (
    <div className="page-wrapper care-plan-page  text">
      <Header type={'h3'} className="page-title">
        <Text type={'span'}> Patient Details </Text>
        <DownArrowIcon
          className={`arrow-icon ml-2 ${showChatHeader ? 'open' : ''}`}
          onClick={() => setShowChatHeader(!showChatHeader)}
        />
      </Header>
      {showChatHeader && (
        <div
          id="chat-header"
          className="chat-header bg-[#00D09033] p-[1rem] pb-1 w-full"
        >
          <div className="chat-content flex flex-col lg:flex-row justify-between items-center lg:items-end">
            <div className="flex items-center">
              <div className="circle-background">
                <NameIcon
                  className="patientname"
                  name={
                    getUuid?.patient_details?.first_name &&
                    getUuid?.patient_details?.last_name
                      ? `${getUuid.patient_details.first_name} ${getUuid.patient_details.last_name}`
                      : 'N/A'
                  }
                />
              </div>
              <div className="name-text pl-3">
                {getUuid?.patient_details?.first_name &&
                getUuid?.patient_details?.last_name
                  ? `${getUuid.patient_details.first_name} ${getUuid.patient_details.last_name}`
                  : 'N/A'}
              </div>
            </div>
            <div className="patient-info flex ">
              <Text type={'p'} className="text-[#7F7F7F] info-label">
                Date of Birth :
              </Text>
              <Text type={'p'} className="text-[#7F7F7F] info-value">
                {getUuid?.patient_details?.birth_date
                  ? getUuid?.patient_details?.birth_date
                  : 'N/A'}
              </Text>
            </div>
            <div className="patient-info flex">
              <Text type={'p'} className="text-[#7F7F7F] info-label">
                Phone :
              </Text>
              <Text type={'p'} className="text-[#7F7F7F] info-value">
                {getUuid?.patient_details?.phone_id
                  ? getUuid?.patient_details?.phone_id
                  : 'N/A'}
              </Text>
            </div>
            <div className="patient-info flex ">
              <Text type={'p'} className="text-[#7F7F7F] info-label">
                Address :
              </Text>
              <Text type={'p'} className="text-[#7F7F7F] info-value">
                {getUuid?.patient_details?.address?.line_1 &&
                getUuid?.patient_details?.address?.line_2
                  ? `${getUuid?.patient_details?.address?.line_1} ${getUuid.patient_details.address?.line_2}`
                  : 'N/A'}
              </Text>
            </div>
          </div>
        </div>
      )}
      <div className="p-2 heading">Care Plan</div>
      <div className="row mb-3">
        <div className="flex-70">
          {/* <div className='p-2 heading'>CARE PLAN</div> */}
          <div className="icon-text-area careplan-column textarea-ant-careplan">
            <div className="textarea-container">
              <TextArea
                className="careplan-column-1 text-style"
                rows={25}
                style={{ resize: 'none' }}
                value={textAreaValue}
                onChange={(e) => setTextAreaValue(e.target.value)}
              />
              <div className="textarea-container">
                <Button className="button">Approve Plan</Button>
              </div>

              <span className="voice-icon-carplan">
                <VoiceIcon />
              </span>
              <span className="Edit-icon-carplan">
                <EditNotesIcon
                  onClick={() => dispatch(editCarePlan(updateCareConnet))}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarePlanPage;
